import { CryptoCoin } from '../types';

export enum OrderFilterType {
    Unallocated = 'unallocated',
    Cancelled = 'cancelled',
    Open = 'open',
    Today = 'today',
    Rejected = 'rejected',
    Latest = 'latest',
    Executed = 'executed',
    Cost = 'cost',
}

export enum OrderType {
    Market = 'MARKET',
    Limit = 'LIMIT',
    Stop = 'STOP',
    StopLimit = 'STOP_LIMIT',
    Spread = 'SPREAD',
    Notional = 'Notional',
    Even = 'Even',
    Credit = 'Credit',
    Debit = 'Debit',
}

export enum OrderTransaction {
    Buy = 'BUY',
    BuyToOpen = 'BUY_TO_OPEN',
    BuyToClose = 'BUY_TO_CLOSE',
    BuyToCover = 'BUY_TO_COVER',
    Sell = 'SELL',
    SellToOpen = 'SELL_TO_OPEN',
    SellToClose = 'SELL_TO_CLOSE',
    ShortSell = 'SHORT_SELL',
    Open = 'OPEN',
    Close = 'CLOSE',
}

export enum OrderActualTransaction {
    Buy = 'B',
    Sell = 'S',
    ShortSell = 'SS',
    BuyToCover = 'BC',
    BuyToOpen = 'BTO',
    BuyToClose = 'BTC',
    SellToOpen = 'STO',
    SellToClose = 'STC',
}

export enum OrderMarket {
    Us = 'U',
    Canada = 'C',
}

export enum AccountType {
    Cash = 1,
    Margin = 2,
}

export enum OrderStatus {
    //Orbis statuses
    Place = 'B',
    AcceptedAtTheExchange = 'W',
    Cancelled = 'C',
    Filled = 'E',
    PartiallyFilled = 'P',
    WaitingForCancellation = 'A',
    WaitingForCancelReplace = 'G',
    Rejected = 'R',
    // AXOS statuses
    Pending = 'PENDING',
    PendingAccount = 'PENDING_ACCOUNT',
    PendingPost = 'PENDING_POST',
    Submitted = 'SUBMITTED',
    PendingCancel = 'PENDING_CANCEL',
    Open = 'OPEN',
    Complete = 'COMPLETE',
    Failed = 'FAILED',
    Error = 'ERROR',
    Unknown = 'UNKNOWN',
}

export enum OrderValidity {
    GoodForDay = 'DAY',
    GoodTilCanceled = 'GTC',
}

export enum OrderMarketTime {
    PreMarket = 'PRE_MARKET',
    CoreMarket = 'CORE_MARKET',
    PostMarket = 'POST_MARKET',
}

export enum ModelReserveType {
    Dollar = 'DOLLAR',
    Percentage = 'PERCENTAGE',
}

export enum ModelFractionalSharePolicy {
    RoundUp = 'RoundUp',
    RoundDown = 'RoundDown',
    Fractional = 'Fractional',
}

export enum AccountStatus {
    Active = 'A',
    Suspended = 'S',
}

export enum AccountClassification {
    Cash = 'CASH',
    Margin = 'MARGIN',
    DayTrader = 'DAY_TRADER',
    IraRolloverAccount = 'IRA_ROLLOVER_ACCOUNT',
    IraTraditional = 'IRA_TRADITIONAL',
    IraRoth = 'IRA_ROTH',
    IraSep = 'IRA_SEP',
    Inventory = 'INVENTORY',
}

export enum QuoteType {
    Realtime = 'REALTIME',
    RealtimeSnapshot = 'REALTIME_SNAPSHOT',
    Delayed = 'DELAYED',
    CBOE1 = 'CBOE1',
    BATS = 'BATS',
}

export enum PositionType {
    Cash = 1,
    Margin = 2,
    Short = 3,
}

export enum SecurityType {
    Equity,
    Option,
    Spread,
    MutualFund,
    Bond,
    Etf,
}

export enum GroupType {
    Household = 'household',
    Strategy = 'strategy',
    Freeform = 'freeform',
}

export enum TopPositionsType {
    Weight = 'weight',
    Gain = 'gain',
    GainPercent = 'gainPercent',
}

export enum OverExposedType {
    Security = 'Security',
    SecurityType = 'SecurityType',
    // Sector = 'Sector',
    Industry = 'Industry',
}

export enum CorporateActionsType {
    TenderOffer = 'TenderOffer',
    PrivatelyHeld = 'PrivatelyHeld',
    Acquisition = 'Acquisition',
    Dividend = 'Dividend',
    Split = 'Split',
    SymbolChange = 'SymbolChange',
    NameChange = 'NameChange',
    Deletion = 'Deletion',
    Addition = 'Addition',
    Suspension = 'Suspension',
    Merger = 'Merger',
    ExchangeChange = 'ExchangeChange',
    CusipChange = 'CusipChange',
    UnitSplit = 'UnitSplit',
    Conversion = 'Conversion',
    Spinoff = 'Spinoff',
    Other = 'Other',
}

export enum TimeRange {
    OneDay = '1d',
    OneMonth = '1m',
    ThreeMonth = '3m',
    SixMonth = '6m',
    SevenMonth = '7m',
    NineMonth = '9m',
    OneYear = '1y',
}

export enum Etf {
    SPY = 'SPY',
    VOO = 'VOO',
    IVV = 'IVV',
    DIA = 'DIA',
}

export enum UserType {
    Advisor = 'RIA',
    Client = 'CLIENT',
}

export enum UserStatus {
    Established = 'ESTABLISHED',
    PasswordExpired = 'PasswordExpired',
    RequiredPasswordChange = 'RequiredPasswordChange',
    InitialPasswordChange = 'InitialPasswordChange',
    Pending2FA = 'Pending2FA',
}

export enum Sectors {
    Others = 'Others',
}

export enum TradeDestination {
    SingleAccount,
    AveragePriceAccount,
    Model,
}

export enum OrderFillType {
    Any = 'ANY',
    AllOrNone = 'AON',
}

export enum MutualFundUnit {
    Unit,
    Dollar,
}

export enum MutualFundCapitalGains {
    Reinvest = 'Reinvest',
    PayInCash = 'PayInCash',
}

export enum MutualFundDividends {
    Reinvest = 'Reinvest',
    PayInCash = 'PayInCash',
}

export enum TimeInForce {
    ImmediateOrCancel = 0,
    FillOrKill = 1,
}

export enum CryptoOrderTransaction {
    Buy = 'buy',
    Sell = 'sell',
}
export enum Consensus {
    StrongBuySpace = 'Strong Buy',
    StrongBuy = 'StrongBuy',
    Buy = 'Buy',
    StrongSellSpace = 'Strong Sell',
    StrongSell = 'StrongSell',
    Sell = 'Sell',
    Hold = 'Hold',
    Neutral = 'Neutral',
}

export enum GlobalSectorCode {
    Cyclical = 1,
    Defensive = 2,
    Sensitive = 3,
}

export enum GlobalGroupCode {
    BasicMaterial = 101,
    ConsumerCyclical = 102,
    FinancialServices = 103,
    RealEstate = 104,
    ConsumerDefensive = 205,
    Healthcare = 206,
    Utilities = 207,
    CommunicationServices = 308,
    Energy = 309,
    Industrials = 310,
    Technology = 311,
}

export enum GlobalIndustryCode {
    Agriculture = 10110,
    BuildingMaterials = 10120,
    Chemicals = 10130,
    ForestProducts = 10140,
    MetalsMining = 10150,
    Steel = 10160,
    VehiclesParts = 10200,
    FurnishingsFixturesAppliance = 10220,
    HomebuildingConstruction = 10230,
    ManufacturingApparelFurniture = 10240,
    PackagingContainers = 10250,
    PersonalServices = 10260,
    Restaurants = 10270,
    RetailCyclical = 10280,
    TravelLeisure = 10290,
    AssetManagement = 10310,
    Banks = 10320,
    CapitalMarkets = 10330,
    Insurance = 10340,
    DiversifiedFinancialServices = 10350,
    CreditServices = 10360,
    REITs = 10420,
    BeveragesAlcoholic = 20510,
    BeveragesNonAlcoholic = 20520,
    ConsumerPackagedGoods = 20525,
    Education = 20540,
    RetailDefensive = 20550,
    TobaccoProducts = 20560,
    Biotechnology = 20610,
    DrugManufacturers = 20620,
    HealthcarePlans = 20630,
    HealthcareProvidersServices = 20645,
    MedicalDevicesInstruments = 20650,
    MedicalDiagnosticsResearch = 20660,
    MedicalDistribution = 20670,
    UtilitiesIndependentPowerProducers = 20710,
    UtilitiesRegulatedWater = 20720,
    TelecommunicationServices = 30810,
    MediaDiversified = 30820,
    InteractiveMedia = 30830,
    OilGas = 30910,
    OtherEnergySources = 30920,
    AerospaceDefense = 31010,
    BusinessServices = 31020,
    Conglomerates = 31030,
    Consttruction = 31040,
    FarmHeavyConstructionMachinery = 31050,
    IndustrialDistribution = 31060,
    IndustrialProducts = 31070,
    Transportation = 31080,
    WasteManagement = 31090,
    Software = 31110,
    Hardware = 31120,
    Semiconductors = 31130,
}

export enum GlobalSubIndustryCode {
    BuildingMaterials = 10120010,
    Chemicals = 10130010,
    SpecialtyChemicals = 10130020,
    LumberWoodProduction = 10140010,
    PaperPaperProducts = 10140020,
    Aluminum = 10150010,
    Copper = 10150020,
    OtherIndustrialMetalsMining = 10150030,
    Gold = 10150040,
    Silver = 10150050,
    OtherPreciousMetalsMining = 10150060,
    CokingCoal = 10160010,
    Steel = 10160020,
    AutoTruckDealerships = 10200010,
    AutoManufacturers = 10200020,
    AutoParts = 10200030,
    RecreationalVehicles = 10200040,
    FurnishingsFixturesAppliances = 10220010,
    ResidentialConstruction = 10230010,
    TextileManufacturing = 10240010,
    ApparelManufacturing = 10240020,
    FootwearAccessories = 10240030,
    PackagingContainers = 10250010,
    PersonalServices = 10260010,
    Restaurants = 10270010,
    ApparelRetail = 10280010,
    DepartmentStores = 10280020,
    HomeImprovementRetail = 10280030,
    LuxuryGoods = 10280040,
    InternetRetail = 10280050,
    SpecialtyRetail = 10280060,
    Gambling = 10290010,
    Leisure = 10290020,
    Lodging = 10290030,
    ResortsCasinos = 10290040,
    TravelServices = 10290050,
    AssetManagement = 10310010,
    BanksDiversified = 10320010,
    BanksRegional = 10320020,
    MortgageFinance = 10320030,
    CapitalMarkets = 10330010,
    FinancialDataStockExchanges = 10330020,
    InsuranceLife = 10340010,
    InsurancePropertyCasualty = 10340020,
    InsuranceReinsurance = 10340030,
    InsuranceSpecialty = 10340040,
    InsuranceBrokers = 10340050,
    InsuranceDiversified = 10340060,
    ShellCompanies = 10350010,
    FinancialConglomerates = 10350020,
    CreditServices = 10360010,
    RealEstateDevelopment = 10410010,
    RealEstateServices = 10410020,
    RealEstateDiversified = 10410030,
    ReitHealthcareFacilities = 10420010,
    ReitHotelMotel = 10420020,
    ReitIndustrial = 10420030,
    ReitOffice = 10420040,
    ReitResidential = 10420050,
    ReitRetail = 10420060,
    ReitMortgage = 10420070,
    ReitSpecialty = 10420080,
    ReitDiversified = 10420090,
    BeveragesBrewers = 20510010,
    BeveragesWineriesDistilleries = 20510020,
    BeveragesNonAlcoholic = 20520010,
    Confectioners = 20525010,
    FarmProducts = 20525020,
    HouseholdPersonalProducts = 20525030,
    PackagedFoods = 20525040,
    EducationTrainingServices = 20540010,
    DiscountStores = 20550010,
    FoodDistribution = 20550020,
    GroceryStores = 20550030,
    Tobacco = 20560010,
    Biotechnology = 20610010,
    DrugManufacturersGeneral = 20620010,
    DrugManufacturersSpecialtyGeneric = 20620020,
    HealthcarePlans = 20630010,
    MedicalCareFacilities = 20645010,
    PharmaceuticalRetailers = 20645020,
    HealthInformationServices = 20645030,
    MedicalDevices = 20650010,
    MedicalInstrumentsSupplies = 20650020,
    DiagnosticsResearch = 20660010,
    MedicalDistribution = 20670010,
    UtilitiesIndependentPowerProducers = 20710010,
    UtilitiesRenewable = 20710020,
    UtilitiesRegulatedWater = 20720010,
    UtilitiesRegulatedElectric = 20720020,
    UtilitiesRegulatedGas = 20720030,
    UtilitiesDiversified = 20720040,
    TelecomServices = 30810010,
    AdvertisingAgencies = 30820010,
    Publishing = 30820020,
    Broadcasting = 30820030,
    Entertainment = 30820040,
    InternetContentInformation = 30830010,
    ElectronicGamingMultimedia = 30830020,
    OilGasDrilling = 30910010,
    OilGasEP = 30910020,
    OilGasIntegrated = 30910030,
    OilGasMidstream = 30910040,
    OilGasRefiningMarketing = 30910050,
    OilGasEquipmentServices = 30910060,
    ThermalCoal = 30920010,
    Uranium = 30920020,
    AerospaceDefense = 31010010,
    SpecialtyBusinessServices = 31020010,
    ConsultingServices = 31020020,
    RentalLeasingServices = 31020030,
    SecurityProtectionServices = 31020040,
    StaffingEmploymentServices = 31020050,
    Conglomerates = 31030010,
    EngineeringConstruction = 31040010,
    InfrastructureOperations = 31040020,
    BuildingProductsEquipment = 31040030,
    FarmHeavyConstructionMachinery = 31050010,
    IndustrialDistribution = 31060010,
    BusinessEquipmentSupplies = 31070010,
    SpecialtyIndustrialMachinery = 31070020,
    MetalFabrication = 31070030,
    PollutionTreatmentControls = 31070040,
    ToolsAccessories = 31070050,
    ElectricalEquipmentParts = 31070060,
    AirportsAirServices = 31080010,
    Airlines = 31080020,
    Railroads = 31080030,
    MarineShipping = 31080040,
    Trucking = 31080050,
    IntegratedFreightLogistics = 31080060,
    WasteManagement = 31090010,
    InformationTechnologyServices = 31110010,
    SoftwareApplication = 31110020,
    SoftwareInfrastructure = 31110030,
    CommunicationEquipment = 31120010,
    ComputerHardware = 31120020,
    ConsumerElectronics = 31120030,
    ElectronicComponents = 31120040,
    ElectronicsComputerDistribution = 31120050,
    ScientificTechnicalInstruments = 31120060,
    SemiconductorEquipmentMaterials = 31130010,
    Semiconductors = 31130020,
    Solar = 31130030,
}

export enum IndustryType {
    Sector = 'SECTOR',
    Group = 'GROUP',
    Industry = 'INDUSTRY',
    SubIndustry = 'SUB_INDUSTRY',
}

export enum IndustrySector {
    ConsumerCyclical = 'CONSUMER_DISCRETIONARY',
    ConsumerDefensive = 'CONSUMER_STAPLES',
    Energy = 'ENERGY',
    FinancialServices = 'FINANCIALS',
    Healthcare = 'HEALTH_CARE',
    Technology = 'INFORMATION_TECHNOLOGY',
    BasicMaterial = 'MATERIALS',
    RealEstate = 'REAL_ESTATE',
    CommunicationServices = 'TELECOMMUNICATION',
    Utilities = 'UTILITIES',
    Industrials = 'INDUSTRIALS',
}

export enum EtfBreakdownDuration {
    OneDay = '1d',
    OneWeek = '1w',
    TwoWeeks = '2w',
    OneMonth = '1m',
}

export enum DocumentType {
    All = 0,
    AccountStatement = 2,
    Corrections = 100,
    R1099 = 102,
    S1042 = 104,
    FMV5498 = 105,
    ESA5498 = 106,
    FMV = 107,
    Q1099 = 108,
    SDIRA = 109,
}

export type Document = {
    url: string;
    documentType: string;
    documentDate: string;
};

export enum EarningsTime {
    AfterClose = 'AFTER_CLOSE',
    PriorOpen = 'PRIOR_OPEN',
    During = 'DURING',
    Other = 'OTHER',
}

export enum IpoActionOption {
    Recent = 'recent',
    Upcoming = 'upcoming',
    Performance = 'performance',
}

export enum IpoDataSortOption {
    OfferPx = 'offerPx',
    Shares = 'shares',
    IpoRet = 'ipoRet',
    IpoSize = 'offerSz',
}

export enum IpoPerformanceRange {
    OneMonth = '1m',
    ThreeMonth = '3m',
    SixMonth = '6m',
    OneYear = '1y',
}

export enum EtfCommonParam {
    Sponsors = 'Sponsors',
    AssetClasses = 'AssetClasses',
    InverseTypes = 'InverseTypes',
    Categories = 'Categories',
    Sectors = 'Sectors',
    LeverageTypes = 'LeverageTypes',
    SectorCodes = 'SectorCodes',
}

export enum EtfFilterMainOptions {
    Overview = 'Overview',
    ETFScreener = 'ETF Screener',
}

export enum EtfAnyFilterOption {
    Any = '',
}

export enum EtfFilterAssetOptions {
    Any = '',
    Allocation = 'Allocation',
    Alternative = 'Alternative',
    Commodities = 'Commodities',
    InternationalEquity = 'International Equity',
    MunicipalBond = 'Municipal Bond',
    SectorEquity = 'Sector Equity',
    TaxableBond = 'Taxable Bond',
    USEquity = 'U.S. Equity',
}

export enum EtfFilterInverseOptions {
    Any = 'ALL',
    LongEtf = 'LONG',
    Inverse = 'SHORT',
}

export enum EtfFilterLeverageOptions {
    Any = 'ALL',
    NoLeverage = 'LEVERAGE_I',
    Leveragex2 = 'LEVERAGE_II',
    Leveragex3 = 'LEVERAGE_III',
    AllLeverage = 'LEVERAGE',
}

export enum EtfBreakdownCategory {
    TopVolume = 'topvolume',
    TopValue = 'topvalue',
    TopChange = 'topchangepc',
    BottomChange = 'bottomchangepc',
}

export enum EtfScreenerSortParams {
    Symbol = 'symbol',
    Last = 'last',
    Change = 'change',
    Volume = 'volume',
    MarketCap = 'marketcap',
    Expense = 'expense',
    Asset = 'asset',
    Sponsor = 'sponsor',
    Category = 'category',
    Leverage = 'leverage',
    CountryPct = 'countrypct',
    ContinentPct = 'countinentpct',
    SectorPct = 'sectorpct',
    Exposure = 'exposure',
}

export enum OptionRadarCategory {
    CallVolCallOiRatios = 'callVolCallOiRatios',
    CallOiPutOiRatios = 'callOiPutOiRatios',
    CallVolPutVolRatios = 'callVolPutVolRatios',
    PutOiCallOiRatios = 'putOiCallOiRatios',
    PutVolCallVolRatios = 'putVolCallVolRatios',
    PutVolPutOiRatios = 'putVolPutOiRatios',
}

export enum OptionRadarOption {
    Call = 'Call',
    Put = 'Put',
}

export enum BankLinkStatus {
    Approved = 'APPROVED',
    Pending = 'PENDING',
    Rejected = 'REJECTED',
    Canceled = 'CANCELED',
    Unknown = 'UNKNOWN',
}

export enum BankAccountType {
    Checking = 'CHECKING',
    Savings = 'SAVINGS',
}
export enum PaidAccountSubtype {
    Checking = 'checking',
    Savings = 'savings',
    Ira = 'ira',
    Student = 'student',
    FourOneK = '401k',
    Mortgage = 'mortgage',
}

export enum MoneyTransferType {
    Deposit,
    Withdraw,
}

export enum CashTransferStatus {
    Placed = 'PLACED',
    Pending = 'PENDING',
    Sent = 'SENT',
    Canceled = 'CANCELED',
    Rejected = 'REJECTED',
    Complete = 'COMPLETE',
    CancelRequested = 'CANCEL_REQUESTED',
    CancelPending = 'CANCEL_PENDING',
    FundsHeld = 'FUNDS_HELD',
    FundsPosted = 'FUNDS_POSTED',
    FundsPaid = 'FUNDS_PAID',
    SentToBank = 'SENT_TO_BANK',
    PendingPrinting = 'PENDING_PRINTING',
    Void = 'VOID',
    Returned = 'RETURNED',
    StopPayment = 'STOP_PAYMENT',
    Unknown = 'UNKNOWN',
}

export enum CashTransfersDirection {
    Outgoing = 'OUTGOING',
    Incoming = 'INCOMING',
}

export enum MarketMostActiveQueries {
    LargestPriceByPercent = 'LP',
    MostActive = 'MA',
    MostActiveByDollarTraded = 'DT',
    MostActiveByPercentPrice = 'MALP',
}

export enum MarketMostAtiveSupportedMarkets {
    Big3 = 'BIG3',
    Nasdaq = 'Nasdaq',
    NYSE = 'NYSE',
    AMEX = 'AMEX',
    OTCk = 'OTC BB',
    OTCi = 'OTC issues',
}

export enum MarketMostActiveSupportedOrders {
    Winners = 'H',
    Losers = 'L',
}

export enum AgreementCode {
    NyseAmex = 'NA',
    DowJones = 'DJ',
    Options = 'O',
    Nasdaq = 'Q',
    SP500 = 'S5',
    Canada = 'CA',
    CboeGlobal = 'BATS',
}

export enum PolicyValuesType {
    Funding = 'funding',
    Trading = 'trading',
    Acat = 'acat',
}

export enum PolicyOnAccount {
    Allow = 'Allow',
    Disallow = 'Disallow',
    AllowWithdrawal = 'AllowWithdrawal',
    AllowBoth = 'AllowBoth',
}

export enum LegalDocumentClassifications {
    Custodial = 'Custodial',
    Funding = 'Funding',
    Banking = 'Banking',
    TermsOfUse = 'TermsOfUse',
}

export const availableCoins: Record<string, CryptoCoin> = {
    BTC: {
        name: 'Bitcoin',
        icon: '₿',
        symbol: 'BTC/USD',
        twitter: 'https://twitter.com/Bitcoin',
        description:
            'Bitcoin (₿) is a decentralized digital currency, without a central bank or single administrator, that can be sent from user to user on the peer-to-peer bitcoin network without the need for intermediaries.Transactions are verified by network nodes through cryptography and recorded in a public distributed ledger called a blockchain. The cryptocurrency was invented in 2008 by an unknown person or group of people using the name Satoshi Nakamoto. The currency began use in 2009 when its implementation was released as open-source software.',
    },
    ETH: {
        name: 'Ethereum',
        icon: 'Ξ',
        symbol: 'ETH/USD',
        twitter: 'https://twitter.com/ethereum',
        description:
            'Ethereum is a decentralized, open-source blockchain with smart contract functionality. Ether (ETH or Ξ) is the native cryptocurrency of the platform. Among cryptocurrencies, Ether is second only to Bitcoin in market capitalization.Ethereum was conceived in 2013 by programmer Vitalik Buterin. Additional founders of Ethereum included Gavin Wood, Charles Hoskinson, Anthony Di Iorio and Joseph Lubin. In 2014, development work commenced and was crowdfunded, and the network went live on 30 July 2015. The platform allows anyone to deploy permanent and immutable decentralized applications onto it, with which users can interact. Decentralized finance (DeFi) applications provide a broad array of financial services without the need for typical financial intermediaries like brokerages, exchanges, or banks, such as allowing cryptocurrency users to borrow against their holdings or lend them out for interest. Ethereum also allows for the creation and exchange of NFTs, which are non-interchangeable tokens connected to digital works of art or other real-world items and sold as unique digital property. Additionally, many other cryptocurrencies operate as ERC-20 tokens on top of the Ethereum blockchain and have utilized the platform for initial coin offerings.',
    },
};

export enum TipranksTrendingStocksFilter {
    Analysts = 'analysts',
    Bloggers = 'bloggers'
}

export enum TipranksTrendingStocksTrendingType {
    MostRated = 'most-rated',
    BestRated = 'best-rated',
    WorstRated = 'worst-rated'
}

export enum TipranksAnalystRatingByStockSort {
    Date = 'date',
    Rank = 'rank'
}